import PageLoader from './utils/PageLoader';
import PageComponentLoader from './utils/PageComponentLoader';

import { pages } from './pages';
import { components } from './components';



(function ($) {

    $(document).ready(function () {
        if (pages.length) {
            let pageLoader = new PageLoader(pages);
            pageLoader.load();
        }

        if (components) {
            let cLoader = new PageComponentLoader(components);
            cLoader.load();
        }
    });

})(jQuery);


// WEBPACK FOOTER //
// ./javascript/main.js